import React from "react";
import type { PermissionType } from "../types";
import { checkPermission } from "../utils";

// 权限守卫组件 - 根据权限决定是否渲染子组件
interface PermissionGuardProps {
  permission?: number | string; // 权限ID或权限名称
  type?: PermissionType; // 权限类型
  children: React.ReactNode;
  fallback?: React.ReactNode; // 无权限时显示的内容
  // 多权限支持
  permissions?: Array<{ permission: number | string; type?: PermissionType }>;
  mode?: "any" | "all"; // 多权限检查模式
}

export const PermissionGuard: React.FC<PermissionGuardProps> = ({
  permission,
  type = "system",
  children,
  fallback = null,
  permissions,
  mode = "any",
}) => {
  // 单一权限检查
  const hasSinglePermission = () => {
    if (!permission) return false;
    return checkPermission(permission, type);
  };

  // 多权限检查
  const hasMultiplePermissions = () => {
    if (!permissions || permissions.length === 0) return false;

    const results = permissions.map(
      ({ permission: perm, type: permType = "system" }) =>
        checkPermission(perm, permType)
    );

    return mode === "any" ? results.some(Boolean) : results.every(Boolean);
  };

  // 决定使用哪种权限检查方式
  const hasPermission =
    permissions && permissions.length > 0
      ? hasMultiplePermissions()
      : hasSinglePermission();

  return hasPermission ? children : fallback;
};
